<template lang="pug">
  v-date-picker(
    ref="datepicker"
    :locale="lang"
    mode="single"
    v-model="date"
    color="green"
    :min-date="minDate"
    :attributes="attrs"
    :popover="{ placement: 'bottom', visibility: 'click' }")
    v-text-field.mb-3(
      :focus="true"
      v-click-outside="closePopover"
      slot-scope="{ inputProps, inputEvents, isDragging }"
      v-bind="inputProps"
      v-on="inputEvents"
      :is-visible-popover="isVisiblePopover"
      is-date-picker
      :label="label | translate")
      template(
        slot="date-picker"
        slot-scope="{ isDatePicker }")
        .v-input__field(
          :class="{'v-input__field--cursor-pointer': isDatePicker}"
          @click="onClick") {{ value }}
      template(slot="icon-right")
        v-icon(
          :icon="['far', 'calendar-alt']")    
</template>

<script>
export default {
  name: 'VDateField',

  props: {
    value: String,
    minDate: {
      type: [Date, String],
      default: null
    },
    label: {
      type: String,
      default: 'base.date'
    }
  },

  data () {
    return {
      attrs: [],
      date: null,
      isVisiblePopover: false,
    }
  },

  computed: {
    lang () {
      const language = this.$store.getters['account/lang']
      return language === 'us' ? 'en' : language
    },

    timezone () {
      return this.$store.getters['account/timezone']
    }
  },

  created () {
    this.attrs = [
      {
        key: 'today',
        highlight: {
          color: 'green',
          fillMode: 'light'
        },
        dates: this.getTodayInTimezone(this.timezone)
      }
    ]
  },

  methods: {
    getTodayInTimezone (timezone) {
      const now = new Date()

      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })

      const parts = formatter.formatToParts(now)
      const dateParts = {}
      for (const part of parts) {
        if (part.type !== 'literal') {
          dateParts[part.type] = part.value
        }
      }

      const dateStr = `${dateParts.year}-${dateParts.month}-${dateParts.day}T00:00:00`
      const dateInTargetTz = new Date(dateStr)
      const utcTimestamp = dateInTargetTz.getTime() - dateInTargetTz.getTimezoneOffset() * 60000

      return new Date(utcTimestamp)
    },

    onInput (e) {
      this.$emit('input', e)
    },

    onClick () {
      const datepicker = this.$refs.datepicker
      const popover = datepicker.$refs.popover
      this.isVisiblePopover = !popover.isVisible
    },

    closePopover () {
      this.isVisiblePopover = false
    },

    // Format date to local date string (YYYY-MM-DD)
    formatToLocalDate (date) {
      if (!date) return null
      const d = new Date(date)
      return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 10)
    }
  },

  watch: {
    date (value) {
      if (!value) {
        this.$emit('input', null)
        return
      }
      const formattedDate = this.formatToLocalDate(value)
      this.$emit('input', formattedDate)
    },

    value: {
      immediate: true,
      handler (value) {
        if (value) {
          const [year, month, day] = value.split('-').map(Number)
          this.date = new Date(year, month - 1, day)
        } else {
          this.date = null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.v-date-field {
  &__input {
    width: 100%;
    font-size: 1.5rem;
    padding: 1rem 0;
    display: block;
    border: none;
    background: transparent;
    border-bottom: .1rem solid $color-gray-light-2;
  }

  &__label {
  }

  &__icon {
  }
}
</style>
